/**
 * This code was generated by Builder.io.
 */
import React from "react";
import ValueItem from "./ValueItem";

const ValuesSection = () => {
  const values = [
    {
      number: "1",
      title: "Customer Centric Approach",
      description:
        "We prioritize understanding and meeting the unique needs of our customers.",
    },
    {
      number: "2",
      title: "Innovation and Adaptability",
      description:
        "Constantly evolving our services and leveraging technology to stay ahead.",
    },
    {
      number: "3",
      title: "Transparency and Trust",
      description:
        "Clear communication and ethical practices are at the core of our operations.",
    },
    {
      number: "4",
      title: "Empathy in Service Delivery",
      description:
        "Ensuring our team is driven by empathy to provide the best possible service to our customers",
    },
  ];

  return (
    <section className="values-section">
      <div className="container">
        <h2 className="about-section-title">The Core Values of Orbit</h2>
        <div className="values-container">
          <img
            loading="lazy"
            src="https://cdn.builder.io/api/v1/image/assets/TEMP/96472b49b1dd3fd415d9b0388a9d2bbef4bc3a679a96e8b7347482b8f4b19815?placeholderIfAbsent=true&apiKey=0dc91187d1fc4cb3931d3d7b27a4a892"
            className="values-image"
            alt="Core values illustration"
          />
          <div className="values-list">
            {values.map((value, index) => (
              <ValueItem key={index} {...value} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ValuesSection;
